import { channels } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function ChannelIndex() {
  return (
    <section id="channels" className="w-full border-b border-foreground-900/10 bg-background-50">
      <div className="mx-auto w-full max-w-[1360px] px-4 py-16 md:px-8 md:py-24">
        <SectionHeading
          index="02"
          kicker="账号与频道汇总"
          title="谁在更新，一栏一栏写清楚"
          description="把常被问到的账号按题材归位，标明它主攻什么、更新节奏如何，找号不再靠别人转述。"
        />

        <div className="mt-12 grid grid-cols-1 gap-x-16 lg:grid-cols-2">
          {channels.map((channel) => (
            <div
              key={channel.id}
              className="flex cursor-pointer gap-5 border-t border-foreground-900/10 py-7 transition-colors hover:border-primary-300"
            >
              <span className="w-10 shrink-0 font-heading text-2xl font-bold text-primary-600">
                {channel.rank}
              </span>
              <div className="min-w-0">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
                  <h3 className="font-heading text-lg text-foreground-950">{channel.name}</h3>
                  <span className="rounded-full border border-foreground-900/15 px-2.5 py-0.5 text-[11px] text-foreground-600">
                    {channel.platform}
                  </span>
                  <span className="text-[11px] text-foreground-500">{channel.handle}</span>
                </div>
                <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">
                  {channel.summary}
                </p>
                <span className="mt-3.5 inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-[11px] text-accent-900">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-price-tag-3-line"></i>
                  </span>
                  {channel.focus}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-start gap-3 rounded-lg border border-dashed border-foreground-900/20 bg-background-100 px-5 py-5 sm:flex-row sm:items-center">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary-200 text-secondary-900">
            <i className="ri-information-line"></i>
          </span>
          <p className="text-sm leading-relaxed text-foreground-600">
            收录并不代表推荐，榜单顺序只反映被问到的频次。发现停更或改名的入口，可在页脚留下线索。
          </p>
        </div>
      </div>
    </section>
  );
}